import { logger } from '@user-portal/logger';
import { ERROR_LEVELS, SENTRY_CABINET } from '@user-portal/sentry-utils';
import { takeEvery } from 'redux-saga/effects';

import { isApiClientError } from 'services/ApiClient';
import sentry from 'services/Sentry/SentryInstance';

import { handleErrorAction } from './actions';
import { HANDLE_ERROR_ACTION } from './actionTypes';

function* handleErrorSaga({ payload: { error, data } }: ReturnType<typeof handleErrorAction>) {
    if (isApiClientError(error)) {
        return;
    }

    logger.error('MB Portal: Logging error from handleErrorSaga:', { error, data });

    yield sentry.logError(error, SENTRY_CABINET, ERROR_LEVELS.ERROR, {
        ...data,
    });
}

export default function* watchHandleErrorAction() {
    yield takeEvery(HANDLE_ERROR_ACTION, handleErrorSaga);
}
